module.exports = __webpack_public_path__ + "static/media/14886364_1236036613133651_94059249_n.e8fb081e.jpg";